'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

exports.default = parser;


function parser(tokens) {
  const ops = tokens.reduce(function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _args$ = args[1];
    const parse = _args$.parse,
          type = _args$.type;

    try {
      return parse.apply(undefined, args);
    } catch (e) {
      throw new Error('Unknown token type: ' + type);
    }
  }, []);
  return ops;
}
module.exports = exports['default'];